<template>
  <div class="container">
    <el-container class="page-container">
      <el-aside width="250px">
        <el-scrollbar>
          <div
            v-if="action === 'edit'"
            class="agent-info"
          >
            <el-avatar
              :src="agent.avatar"
              :size="50"
            />
            <div class="detail-info">
              <div class="agent-name">{{ agent.agent_name }}</div>
              <div class="agent-brief">{{ agent.brief }}</div>
            </div>
          </div>

          <el-menu
            active-text-color="#000000"
            text-color="#4e5058"
            :default-active="activeMenu"
          >
            <el-menu-item
              v-for="(item, index) in menuList"
              :key="index"
              :index="item.index"
              @click="changeMenu(item, index)"
            >
              <el-icon>
                <Setting v-if="index === 0" />
                <Connection v-if="index === 1" />
                <DataAnalysis v-if="index === 2 " />
                <headset v-if="index === 3" />
                <UserFilled v-if="index === 4" />
              </el-icon>
              {{ item.title }}
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </el-aside>

      <el-container class="page-container">
        <el-header>
          {{ activeMenuTitle }}
        </el-header>
        <el-main>
          <router-view v-slot="{ Component }">
            <transition
              mode="out-in"
              name="move"
            >
              <component
                :is="Component"
                @changeNav="changeMenu"
              />
            </transition>
          </router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {
  Aim,
  Calendar,
  Connection,
  DataAnalysis, Guide,
  Headset, Place, QuestionFilled,
  Setting,
  UserFilled
} from '@element-plus/icons-vue'

export default {
  name: 'PcAgentIndex',
  components: {
    QuestionFilled, Connection, DataAnalysis, UserFilled, Setting,
    Place, Guide, Aim, Calendar, Headset
  },
  data() {
    return {
      menuList: [
        {index: '1', title: this.$t('views.agent.agent_settings'), name: 'AgentCreation', path: '/agent/index/creation'},
        {index: '2', title: this.$t('views.agent.integration'), name: 'AgentLink', path: '/agent/index/link'},
        {index: '3', title: this.$t('views.agent.data_analysis'), name: 'AgentDataAnalysis', path: '/agent/index/data-analysis'},
        {index: '4', title: this.$t('views.agent.user_feedback'), name: 'AgentUserFeedback', path: '/agent/index/user-feedback'},
        {index: '5', title: this.$t('views.agent.member_settings'), name: 'AgentMemberSetting', path: '/agent/index/member-setting'}
      ],
      curPath: '',
      action: 'add',
      activeMenu: '1',
      activeMenuTitle: this.$t('views.agent.agent_settings'),
      agent: {}
    }
  },
  computed: {},
  mounted() {
    this.curPath = this.$router.currentRoute.value.path
    const menus = this.menuList.filter(menu => menu.path === this.curPath)
    if (menus && menus.length > 0) {
      this.activeMenu = menus[0].index
    } else {
      this.$router.push({path: '/agent/index/creation'})
    }
  },
  methods: {
    changeMenu(item, index) {
      this.curPath = item.path
      this.activeMenu = item.index
      this.activeMenuTitle = item.title
      this.$router.push({path: item.path})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/views/agent/index';
</style>
